import { MergeRequestBase } from '../types/MergeRequest';

type GetPipelineCountProps = {
  baseUrl: string;
  token: string;
  mr: MergeRequestBase;
};

export async function getPipelineCount({
  baseUrl,
  token,
  mr,
}: GetPipelineCountProps): Promise<number> {
  if (!baseUrl || !token || !mr) {
    throw new Error('Proxy base URL or MR not available');
  }

  const fetchUrl = new URL(`${baseUrl}/renovate-pipelines`);
  fetchUrl.search = new URLSearchParams({
    projectId: mr.project_id.toString(),
    mrId: mr.iid.toString(),
    per_page: '10',
    page: '1',
  }).toString();

  const response = await fetch(fetchUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    // Error response: ex if pipeline not found then don't raise but set -1 as pipeline count.
    return -1;
  }

  const pipelineCounts = response.headers.get('x-total');
  if (pipelineCounts) {
    return Number(pipelineCounts);
  }

  return 0;
}
